/**
 * New reorder functionality
 */
let reorderEleGlobal = '';
let productIdGlobal = '';
let selectedPropsGlobal = '';
let reorderTokenGlobal = '';
const designsContainer = document.getElementById('design-container');

// Utility to get values safely from inputs or elements
const getValue = (selector) => $(selector).val() || '';

function setupPagination(response) {
    const paginationContainer = $('#pagination-container');
    paginationContainer.empty(); // Clear previous pagination

    for (let i = 1; i <= response.last_page; i++) {
        paginationContainer.append(`<a href="#" class="pagination-link" data-page="${i}">${i}</a>`);
    }

    paginationContainer.append(`<span>` + translations.page + ` ${response.current_page} ` + translations.of + ` ${response.last_page}</span>`);
}
function decodeHtmlEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
}

function decodeUtf8(text) {
    try {
        return decodeURIComponent(escape(text));
    } catch {
        return text; // Return original text if decoding fails
    }
}

function decodeJsonKeysAndValues(encodedJsonString) {
    // Step 1: Decode HTML entities in the entire JSON string
    var decodedString = decodeHtmlEntities(encodedJsonString);

    // Step 2: Parse the decoded JSON string into an object
    var parsedObject = JSON.parse(decodedString);

    // Step 3: Decode keys and values recursively
    function decodeObject(obj) {
        var decodedObject = {};
        for (let [key, value] of Object.entries(obj)) {
            // Decode keys
            var decodedKey = decodeUtf8(decodeHtmlEntities(key));

            // Decode values
            if (typeof value === "string") {
                value = decodeUtf8(decodeHtmlEntities(value));
            } else if (typeof value === "object" && value !== null) {
                value = decodeObject(value); // Recursively decode nested objects
            }

            decodedObject[decodedKey] = value;
        }
        return decodedObject;
    }

    var decodedJson = decodeObject(parsedObject);

    // Step 4: Stringify the decoded JSON object
    return JSON.stringify(decodedJson, null, 4);
}


/**Start load designs used for the account view my designs */
function loadDesigns(page, location = null) {
    openHoneyLoader();
    page = Number(page);

    const customerData = {
        store: storeGlobal,
        customerId: customerGlobalId,
        email: customerGlobalEmail,
        page,
    };

    fetch(`${backendURL}/shopify/getCustomerDesigns`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: customerData }),
    })
        .then(response => response.json())
        .then(data => {
            if (data.status === 200) {
                const designs = data.body.data;
                //get unique IDs to group
                const uniqueProductIds = [...new Set(designs.map(design => design.product_id))];
                // manual sorting WRT ids
                const sortedDesigns = uniqueProductIds.flatMap(productId =>
                    designs.filter(design => design.product_id === productId)
                );


                if (location == 'my-account') {
                    // render designs on my account page
                    renderLatestDesignTiles(designs, location);
                } else {
                    // render designs on my design page
                    renderDesigns(sortedDesigns, location);
                    // Handle pagination
                    handlePagination(data.body.current_page, data.body.last_page, page);
                }

                closeHoneyLoader();
            } else if (data.status === 600) {
                displayErrorMessage(translations.design_load_error_message);
            }
        })
        .catch(error => {
            console.error("Request failed: ", error);
            displayErrorMessage(translations.design_load_error_message);
        });
}

function renderLatestDesignTiles(designs, location, orderDesignContainer) {
    let html = '';

    if (!Array.isArray(designs) || designs.length === 0) {
        html = '<p>Keine Designs gefunden.</p>';
    } else {
        const designsToRender = location === 'order-designs'
            ? designs
            : designs.slice(0, 3);

        html = designsToRender
            .map(design => createDesignIconHtml(design, location))
            .join('');
    }

    const container = orderDesignContainer || designsContainer;
    container.innerHTML += html;

    closeHoneyLoader();
}

function renderDesigns(designs, location) {

    let html = Array.isArray(designs) && designs.length === 0
    ? '<p>Keine Designs gefunden.</p>'
    : '';
    let previousProductId = null;

    designs.forEach(design => {
        let productTitle = '';
        let rowHtml = '';

        if (previousProductId === null || previousProductId !== design.product_id) {
            productTitle = createProductTitleHtml(design);
            rowHtml += '<div class="image-row">';
        }

        rowHtml += createDesignIconHtml(design);

        if (previousProductId === null || previousProductId !== design.product_id) {
            rowHtml += '</div>';
            html += `<div class="product-design-block">${productTitle}${rowHtml}</div>`;
        } else {
            // Append to the last image-row (optional in string version, or handled differently)
            html = html.replace(/(<div class="image-row">)([\s\S]*?)(<\/div><\/div>)$/,
                (match, p1, p2, p3) => `${p1}${p2}${createDesignIconHtml(design)}${p3}`);
        }

        previousProductId = design.product_id;
    });

    designsContainer.innerHTML += html;
}

function createProductTitleHtml(design, location) {
    let productName = design.product_name || 'Empty';
    productName = productName.replace(/ - /g, "–");
    const [titlePart, subtitlePart] = productName.split('–').map(part => part.trim());
    let titleHtml = '';
    let dimensionsHtml = '';
    if (location === 'my-account' || location === 'order-designs') {
        titleHtml = `<p class="design-product-title">${titlePart}</p>`;
        titleHtml += (typeof subtitlePart !== 'undefined')
            ? `<p class="design-product-subtitle">${subtitlePart}</p>`
            : '';
    }else{
        titleHtml = `<h3 class="design-product-title">${titlePart}${subtitlePart ? ' - ' + subtitlePart : ''}</h3>`;

        dimensionsHtml = `<p class="label__dimensions">${translations.dimensions_of_label_text} : ${design.width} x ${design.height} mm</p>`;
    }
    return titleHtml + dimensionsHtml;
}

function convertUTCToLocalAdjusted(utcString) {
  const date = new Date(utcString);

  // Add 1 hour offset manually
  date.setHours(date.getHours() + 1);

  const formatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  return formatter.format(date).replace(/\//g, ".");
}



function createDesignIconHtml(design, location) {

    let dateHtml = '';
    let productTitle = '';

    dateHtml = `<p class="design-date"><strong> ${translations.design_modified_date}: </strong> ${convertUTCToLocalAdjusted(design.updated_at)}</p>`;
    if (location == 'my-account' || location == 'order-designs') {
        productTitle = createProductTitleHtml(design, location);
    }

    const reorderAttributes = `
        data-product-properties='${decodeJsonKeysAndValues(design.selected_properties)}'
        data-product-id="${design.product_id}"
        data-product-width="${design.width}"
        data-product-height="${design.height}"
        data-product-name="${design.product_name}"
        data-design-token="${design.design_reference}"`;

    const removeAttributes = `
        data-id="${design.id}"
        data-customer-id="${design.customer_id}"
        data-design-id="${design.design_reference}"`;


    return `
        <div class="design-icon">
            ${ productTitle}
            <figure class="lazy-image lazy-image--animation">
                <img src="${design.image}" class="img zoom-image" width="150" onload="this.parentNode.classList.add('lazyloaded')"/>
            </figure>
            <p></p>
            ${ location !== 'order-designs' ? dateHtml : '' }

            <div class="icon-btn-section">
                <button class="button button--outline button--icon btn-reorder-item" onclick="processReorderDesign(this)" ${reorderAttributes}>
                    ${ location == 'order-designs' ? cartIcon + translations.order_again : editIcon + translations.design_edit_button_name }
                </button>
                ${location !== 'order-designs' ? `
                    <button class="button button--outline button--icon btn--remove" onclick="processRemoveDesign(this)" ${removeAttributes}>
                        ${deleteIcon}${translations.design_delete_button_name}
                    </button>` : ''
                }
            </div>
        </div>`;
}

function handlePagination(currentPage, lastPage, nextPage) {
    const loadMoreButton = document.getElementById('load-more');
    if (currentPage !== lastPage) {
        loadMoreButton.style.display = 'block';
        loadMoreButton.setAttribute('data-page', nextPage + 1);
    } else {
        loadMoreButton.style.display = 'none';
    }
}

function displayErrorMessage(message) {
    const errorMessage = document.createElement('h5');
    errorMessage.textContent = message;
    document.getElementById('designs-container').appendChild(errorMessage);
}
/* END load designs used for the account view my designs */


// Helper function to determine if a value is a plain object (not an array or null)
function isPlainObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
}

// Optimized function to get selected property values
function getSelectedPropsValues(dataArray, searchItem) {

    // Handle case where dataArray is an object and contains the searchItem as a key
    if (isPlainObject(dataArray) && searchItem in dataArray) {

        return dataArray[searchItem];
    }

    // Handle case where dataArray is an array of objects and contains the searchItem as an object with a matching name
    if (Array.isArray(dataArray)) {
        const foundItem = dataArray.find(item => item.name === searchItem);

        return foundItem ? foundItem.value ?? '' : '';
    }

    return '';
}


const printlaneCallback = (id, token, image) => {
    // Close the app
    printlane.close();

    openHoneyLoader()

    // Check if the token is valid
    if (token.length === 0) return;

    // Create a reference and key for local storage
    const reference = `${id}.${token}`;

    // Update the product properties with the customization reference
    customReorderProductToCart['properties']['customization reference'] = reference;

    const labelDesignProps = {
        productId: Number(reorderEleGlobal.attr('data-product-id').trim()),
        productName: reorderEleGlobal.attr('data-product-name').trim(),
        productSKU: '',
        store: storeGlobal,
        variantId: customReorderProductToCart['variantId'] || '',
        customerId: customerGlobalId,
        selectedProperties: customReorderProductToCart['properties'] || '',
        customerEmail: customerGlobalEmail,
        customerName: customerGlobalFirstName,
        labelWidth: Number(reorderEleGlobal.attr('data-product-width').trim()),
        labelHeight: Number(reorderEleGlobal.attr('data-product-height').trim()),
        designBase64Format: '',
        token: reference,
        event: 'AddToCart',
        nickName: 'item-cart-design',
    };

    getLabelDesignOnReorder(labelDesignProps, 'cart');
    // postSavedDesign(labelDesignProps, 'cart');

};


function openPrintlaneReorderEditor() {

    printlane.open({
        shop: printlaneShopId,
        customerDesignReference: reorderTokenGlobal,
        language: document.documentElement.lang,
        callback: printlaneCallback,
        options: {
            generateThumbnail: true,
            generateThumbnailType: 'base64',
        }
    });
}

// function to remove design from the DB
function processRemoveDesign(ele, mode = 'delete') {

    if(mode != 'cartDelete'){
        const confirmation = window.confirm("Bist du sicher, dass du dieses Design löschen möchtest?");

        if (!confirmation) {
            return; // Stop if user cancels
        }
    }

    openHoneyLoader();

    const deleteObj = {
        customerId: customerGlobalId,
        token: $(ele).attr('data-design-id')?.trim(),
        event: mode
    };

    postSavedDesign(deleteObj, mode, $(ele));
}

// Function to process reorder design
function processReorderDesign(ele) {
    openHoneyLoader();
    reorderEleGlobal = $(ele);
    reorderTokenGlobal = reorderEleGlobal.attr('data-design-token').trim();
    selectedPropsGlobal = reorderEleGlobal.attr('data-product-properties').trim();
    // if old orders have A4-bogen
    selectedPropsGlobal = selectedPropsGlobal.replace("A4-Bogen", customProperties.a4Label);

    const parsedObject = cleanParsedObject(JSON.parse(selectedPropsGlobal));
    const productName = reorderEleGlobal.attr('data-product-name') || '';

    const postData = {
        "quantity": Number(getSelectedPropsValues(parsedObject, customProperties.numberOflabels)),
        "executiontype": getSelectedPropsValues(parsedObject, customProperties.labelType),
        "materialType": getSelectedPropsValues(parsedObject, customProperties.material),
        "glueType": getSelectedPropsValues(parsedObject, customProperties.adhesive),
        "width": Number(reorderEleGlobal.attr('data-product-width').trim()),
        "height": Number(reorderEleGlobal.attr('data-product-height').trim()),
        "productId": Number(reorderEleGlobal.attr('data-product-id').trim()),
        "productSKU": getSelectedPropsValues(parsedObject, 'SKU'),
        "windingDirection": getSelectedPropsValues(parsedObject, customProperties.windingDirection),
        "voraus": getSelectedPropsValues(parsedObject, customProperties.windingLeftRight),
        "shop" : storeGlobal
    };

    // Winding direction
    if (postData['executiontype'] == customProperties.rollLabel) {

        if (productName.includes('Gewährverschluss')) {
            postData['windingDirection'] = customProperties.windingNotPossible;
            parsedObject[customProperties.windingDirection] = customProperties.windingNotPossible;
        }
        else if (postData['windingDirection'] == '') {
            postData['windingDirection'] = customProperties.windingNoneNeeded;
        }
    }
    customReorderProductToCart['properties'] = parsedObject;
    createCustomBackendProduct(postData, parsedObject, 'reorder');
}

function getCustomerOrderDesigns(orderId = '', productIds = '', variantIds = '', customerId = '', designIds = '', page = 'my-designs') {
    return new Promise((resolve, reject) => {
        const orderElementId = orderId.replace('#', '');
        const loader = $(`.viewDesignsBtnLoader${orderElementId}`);
        const designContainer = document.getElementById(`design-container-${orderElementId}`);

        if (designContainer && designContainer.children.length > 0) {
            $('.image-container').empty();
            $('.image-container').hide();
            loader.hide();
            return resolve({ status: 200, message: "Closed design container" });
        }

        loader.show();
        $(this).attr('disabled', 'disabled');

        const customerData = {
            productIds: productIds,
            store: storeGlobal,
            customerId,
            orderId,
            variantIds,
            designIds,
            page
        };

        $.ajax({
            url: `${backendURL}/shopify/getCustomerOrderDesigns`,
            type: "POST",
            crossDomain: true,
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({ data: customerData }),
            success: function (response) {
                if (response.status === 200) {
                    $('.image-container').empty();
                    $('.image-container').hide();
                    $('#design-container-' + orderId).css('display', 'grid');
                    renderLatestDesignTiles(response.body, 'order-designs', designContainer);
                    resolve(response);
                } else {
                    designContainer.innerHTML += '<h5>' + translations.design_load_error_message + '</h5>';
                    reject(new Error("Invalid response status"));
                }
            },
            error: function (xhr, status, error) {
                console.error("Request failed:", status, error, xhr.responseText);
                document.getElementById(`design-container-${orderElementId}`).innerHTML += '<h5>' + translations.design_load_error_message + '</h5>';
                reject(error);
            }
        });
    });
}

/**End of new reorder */

function postSavedDesign(param, mode = '', element = '') {
    param.userDeviceReferenceId = userGlobalUUID;
    if (param.cartToken && param.cartToken === "00000") {
        param.cartToken = cartGlobalToken;
    }
    $.ajax({
        url: `${backendURL}/shopify/processCustomerDesign`,
        type: "POST",
        crossDomain: true,
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ data: param })
    }).done(function (response) {

        if (mode === 'cart-label-edit') {
            // edit label from cart page: customer can login or without login should work
            window.location.href = '/cart';
        }

        if (response.status === 200) {
            if (mode === 'delete') {
                // delete mode from the view all designs
                element.closest('.design-icon').remove();
                closeHoneyLoader();
            } else if (mode === 'cartDelete') {
                // delete from cart only
                window.location.href = '/cart';
            } else if (mode === 'guest-add-to-cart') {

                addProdToCart(customProductToCart['variantId'], 1, customProductToCart['properties']);

            } else if (mode === 'cart') {
                // Add product to the cart
                // return true;
                addProdToCart(customReorderProductToCart['variantId'], 1, customReorderProductToCart['properties']);
            } else {
                console.log('saved')
            }

        } else if (response.status === 600) {
            console.log(response, '----4');
        }
    }).fail(function (response) {
        console.error(response, 'Failed to save design');
    });
}

function postRemoveDesign(param) {
    $.ajax({
        url: `${backendURL}/shopify/removeCustomerDesign`,
        type: "POST",
        crossDomain: true,
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ data: param })
    }).done(function (response) {

        if (response.status === 200) {
            console.log('remove design success');
        } else if (response.status === 600) {
            console.log(response, 'remove design error');
        }
    }).fail(function (response) {
        console.error(response, 'Failed to delete the design');
    });
}


function getLabelDesignProps() {
    return {
        productId: getValue('#productId'),
        productName: getValue('#productName'),
        productSKU: getValue('#productSKU'),
        store: storeGlobal,
        variantId: customProductToCart.variantId || '',
        customerId: customerGlobalId,
        selectedProperties: customProductToCart.properties || '',
        customerEmail: customerGlobalEmail,
        customerName: customerGlobalFirstName,
        labelWidth: getValue('#labelWidth'),
        labelHeight: getValue('#labelHeight'),
        designBase64Format: '',
        token: '',
        event: '',
        nickName: '',
        userDeviceReferenceId: '',
        cartToken: cartGlobalToken
    };
}

async function getLabelDesignOnReorder(labelDesignProps, mode = '') {
    labelDesignProps.designBase64Format = await printlane.loadThumbnail(labelDesignProps.token, 'base64');
    labelDesignProps.cartItem = 1;
    localStorage.removeItem('colorlab-'+labelDesignProps.token);
    postSavedDesign(labelDesignProps, mode);
}

async function getLabelDesignThumb(token, event, nickName) {
    var labelDesignProps = getLabelDesignProps();
    labelDesignProps.designBase64Format = await printlane.loadThumbnail(token, 'base64');
    localStorage.removeItem('colorlab-'+token);
    labelDesignProps.token = token;
    labelDesignProps.event = event;
    labelDesignProps.nickName = nickName || getValue('#productName');
    customProductToCart['properties']['customization reference'] = token;
    if ((!customerGlobalId || !customerGlobalEmail) && nickName != 'item-cart-design') {

        // Show login modal if not logged in
        openModal(labelDesignProps);

    } else {

        // openHoneyLoader();
        if(event !== 'AddToCart'){
            $('.notifications').hide();
            postSavedDesign(labelDesignProps);
        }
    }

    if (event == 'AddToCart') {

        openHoneyLoader();

        // setPrintlaneImageInLocal(token,labelDesignProps.designBase64Format);
        labelDesignProps.cartItem = 1;

        postSavedDesign(labelDesignProps, 'guest-add-to-cart');
    }
}

function searchDesigns(ele) {

    const keyword = document.getElementById('searchKeyword').value.trim();
    const errorDiv = document.getElementById('designSearchErrorMessage');
    errorDiv.innerText = '';
    if (!keyword) {
        errorDiv.style.display = 'block';
        errorDiv.innerText = translations.design_search_term;
        return;
    }
    // Display loader (optional)
    openHoneyLoader();
    designsContainer.innerHTML = '<p style="text-align:center">' + translations.design_loading_message + '</p>';

    const customerData = {
        store: storeGlobal,
        customerId: customerGlobalId,
        email: customerGlobalEmail,
        keyword: keyword
    };

    // AJAX call to fetch designs
    fetch(`${backendURL}/shopify/searchDesign`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: customerData }),
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 200) {
                const designs = data.body.data;
                designsContainer.innerHTML = ''; // Clear designs container
                closeHoneyLoader();
                renderDesigns(designs); // Function to render designs
            } else {
                closeHoneyLoader();
                errorDiv.style.display = 'block';
                errorDiv.innerText = translations.no_design_found_message;
                designsContainer.innerHTML = ''; // Clear designs container
            }
        })
        .catch((error) => {
            closeHoneyLoader();
            console.error('Error fetching designs:', error);
            errorDiv.style.display = 'block';
            errorDiv.innerText = translations.no_design_found_error_message;
            designsContainer.innerHTML = ''; // Clear designs container
        });
}
